import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms"

export class FileValidator {
    /**
     * Function to control content of files
     *
     * @param bytes max number of bytes allowed
     *
     */
    static maxContentSize(bytes: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const actualSize =
                control.value instanceof FileList
                    ? calculateSize(control.value)
                    : control.value instanceof File
                      ? calculateSize([control.value])
                      : 0
            return actualSize > bytes
                ? {maxContentSize: {actualSize: actualSize, maxSize: bytes}}
                : null
        }
    }

    static nrFiles(nr: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!(control.value instanceof FileList)) return null
            const actualNr = control.value.length
            return actualNr === nr
                ? null
                : {nrFiles: {required: nr, actual: actualNr}}
        }
    }
}

function calculateSize(list: FileList | readonly File[]) {
    let size = 0
    for (let index = 0; index < list.length; index++) {
        const file = list[index]
        if (file) {
            size += file.size
        }
    }
    return size
}
